import {
    RpaShopCaptureVO,
    LoginErpRpaShopCaptureUsingGetParams,
    CheckUrlUsingGetParams,
    CheckUrlVo,
    FollowRpaAddParam,
    GetFollowedCountUsingGetParams,
    FeedbackParam,
} from '@servicesTypings/companyRequest'
import { RpaFavoritesParam } from '@servicesTypings/drpRequest'
import request from '@/utils/requestWebApiUse'
import { transformDataParams2 } from '@/utils/public'
import { companyRequest, securityRequest, drpRequest } from '@/utils/request'

const baseApi = '/jst-data-report/getData/transportData'

type BaseFetchType = (apiCode: any) => (params?: {}) => Promise<API.RootObject<any>>
const baseFetch: BaseFetchType = (apiCode: any) => {
    return (params = {}) =>
        new Promise((resolve, reject) => {
            request(`${baseApi}`, {
                method: 'POST',
                data: transformDataParams2({
                    apiCode,
                    bizDomain: 'gylBizCenter',
                    apiParams: params,
                }),
            })
                .then(response => {
                    resolve(response)
                })
                .catch(reject)
        })
}

// 商品列表
export const queryGoodsList = baseFetch('rpa_platform_shop_item')

// 店铺/直播间基础信息
const queryShopAndLiveRoom = baseFetch('rpa_platform_shop_info')

// RPA采集数据类目列表--商家侧
export const queryShopCategory = baseFetch('rpa_platform_shop_category')

// 发现新款 数字统计
export const queryRuleIdCount = baseFetch('rpa_platform_shop_rule_item_count')

// 获取关注的平台列表
function getFollowedPlatforms({ data, params }) {
    return companyRequest.post('/company/rpashop/listFollowedPlatforms', { data, params })
}

// 获取未关注的平台列表
function getUnFollowedPlatforms(params) {
    return companyRequest.get('/company/rpashop/getUnFollowedPlatforms', { params })
}

// 关注直播、店铺
/**
 * 关注直播、店铺
 */
export function followRpa(data: RpaFavoritesParam): API.Res<boolean> {
    return drpRequest.post('/favorites/followRpa', { data })
}

// 取消关注直播、店铺
/**
 * 取消关注直播、店铺
 */
export function unFollowRpa(data: RpaFavoritesParam): API.Res<boolean> {
    return drpRequest.post('/favorites/unFollowRpa', { data })
}

// 已关注的平台列表的数量
/**
 * 获取关注的平台列表
 */
export function getFollowedCount(params: GetFollowedCountUsingGetParams): API.Res<number> {
    return companyRequest.get('/company/rpashop/getFollowedCount', { params })
}

// 商家反馈
/**
 * submit
 */
export function feedbackSubmit(data: FeedbackParam): API.Res<object> {
    return companyRequest.post('/feedback/submit', { data })
}

// 获取平台数据
export function queryRpaPlatform() {
    return securityRequest.get('/security/configV2/find?key=RPA_PLATFORM_SUPPORTED')
}

// 获取店铺数据
export function queryRpaShopType() {
    return securityRequest.get('/security/configV2/find?key=RPA_SHOP_TYPE_SUPPORTED')
}

// 获取需要支持的平台
export function queryRpaNeedPlatform() {
    return securityRequest.get('/security/configV2/find?key=RPA_FEEDBACK_NEED_SUPPORT')
}

const getAnchorList = api => {
    return (params = {}) =>
        new Promise((resolve, reject) => {
            api(params)
                .then(async response => {
                    const { data, success, total } = response || {}
                    if (success) {
                        if (Array.isArray(data) && data.length) {
                            const shopCodes = data.map(v => v.shopId)
                            try {
                                const {
                                    data: infoData,
                                    msg: infoMessage,
                                    success: infoSuccess,
                                } = await queryShopAndLiveRoom({ shopCodes })
                                if (infoSuccess && Array.isArray(infoData)) {
                                    const completeData = data.reduce((result, item) => {
                                        const current = infoData.find(i => String(i.shop_code) === String(item.shopId))

                                        result.push({
                                            ...item,
                                            _platform: current?.platform,
                                            shop_img: current?.shop_img,
                                            shop_name: current?.shop_name || item.shopId,
                                            shop_session_id: current?.shop_session_id,
                                            gtime: current?.gtime,
                                        })
                                        return result
                                    }, [])

                                    resolve({
                                        data: completeData,
                                        success: true,
                                        message: '',
                                        total,
                                    })
                                } else {
                                    const tempData = data.map(v => ({ ...v, shop_name: v.shopId }))
                                    resolve({
                                        data: tempData,
                                        success: true,
                                        message: '',
                                        infoMessage,
                                        total,
                                    })
                                }
                            } catch (error) {
                                console.error('catchError', error)
                                const tempData = data.map(v => ({ ...v, shop_name: v.shopId }))
                                resolve({
                                    data: tempData,
                                    success: true,
                                    message: '',
                                })
                            }
                        }

                        resolve(response)
                    } else {
                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        })
}

export const getUnFollowedList = getAnchorList(getUnFollowedPlatforms)

export const getFollowedList = getAnchorList(getFollowedPlatforms)

// 获取店铺采集进度统计
/**
 * 获取店铺采集进度统计
 */
export function captureStatistics(): API.Res<RpaShopCaptureVO> {
    return companyRequest.get('/company/rpashop/captureStatistics')
}

// 是否有关注私域主播
/**
 * 是否有关注私域主播
 */
export function isPlatformTypePrivate(): API.Res<boolean> {
    return companyRequest.get('/company/rpashop/isPlatformTypePrivate')
}

// 跳转rpa工作台
/**
 * 查看采集数据
 */
export function loginErpRpa(params: LoginErpRpaShopCaptureUsingGetParams): API.Res<string> {
    return companyRequest.get('/joinLoginErp/loginErpRpaShopDetail', { params })
}

// 校验链接
/**
 * 校验链接
 */
export function checkLink(params: CheckUrlUsingGetParams): API.Res<CheckUrlVo> {
    return companyRequest.get('/company/rpashop/checkUrl', { params })
}

// 添加关注的平台
/**
 * 添加关注的平台
 */
export function addFollow(data: FollowRpaAddParam): API.Res<null> {
    return companyRequest.post('/company/rpashop/addFollow', { data })
}
